import * as React from 'react';
import ContentModal from '../components/content-modal';
import MailIcon from '../../assets/images/mail-icon.png';
import AlertsSubscribe from '../../components/alerts';
import styled from 'styled-components/native';
import config from './config';

const Screen = styled(ContentModal)`
  position: absolute;
  top: ${config.modals.top}px;
  right: 15px;
  width: 33vw;
`;

export default function AlertsSubscribeScreen() {
  return (
    <Screen title="Subscribe to Beach Alerts" icon={MailIcon}>
      <AlertsSubscribe />
    </Screen>
  );
}
